import React, { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import Signbutton, { Debtbutton } from "../../forms/button";
import { Input } from "../../forms/input";
import { Checkbox } from "@material-ui/core";
import {
  EXISTING,
  NEW,
  NEWP,
  YES,
  REGULAR,
  PURCHASE,
  SIP_TRANS_TYPE,
  INVESTMENT_FREQUENCY,
  SIP_DAY,
  SIP,
  NO,
  PAYMENT_MODE,
} from "../../../store/types";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";
import {
  validateSubBroker,
  swpOptions,
  getNewPurchaseFundList,
  getOtherSchemes,
  getAssetClasses,
  CalcSIPEnddt,
  setSipDetails,
  submitPurchaseData,
  showPurchaseConfirmation,
  getMinimumAmount,
  EBamountValidation,
  saveTransactionDetails,
  getCheckPanKotm,
  getCheckPanAotm,
} from "../../../store/actions";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { NEW_TRANSACTION_URL , countrycodeOptions } from ".";
import { isBefore, isAfter, isEqual } from "date-fns";
const initialState = {
  fund: { value: "" },
  funds: [],
  folio: { value: "" },
  folios: [],
  category: { value: "" },
  minimumLumpsumAmout: "",
  categories: [],
  scheme: { value: "" },
  schemes: [],
  investmentFrequency: { value: "" },
  frequencies: [],
  installments: { value: "" },
  sipDay: { value: "" },
  sipDays: [],
  sip_start_date: { value: "" },
  sip_end_date: { value: "" },
  installmentAmount: { value: "" },
  investmentAmount: { value: "" },
  mode: { value: "" },
  perpetualSip: false,
  modes: [],
  minAmount: "",
  kotm: false,
  selectedKotm: { value: "" },
  umrn: [],
};
class Sip extends Component {
  constructor(props) {
    super(props);
    const { sipDetails, location, fundList, history } = this.props;
    const { state } = location;
    const checkExisting =
      !!fundList && fundList.find((ele) => ele.Fund === "189" && !!ele.Acno);
    const checkMode =
      !!history &&
      !!history.location &&
      !!history.location.state &&
      !!history.location.state.mode
        ? history.location.state.mode
        : !!sipDetails && !!sipDetails.mode && !!sipDetails.mode.value
        ? sipDetails.mode.value
        : "";

    const checkPan =
      !!history &&
      !!history.location &&
      !!history.location.state &&
      !!history.location.state.pan
        ? history.location.state.pan
        : !!sipDetails && !!sipDetails.pan && !!sipDetails.pan.value
        ? sipDetails.pan.value
        : "";
    const checkfolio = {
      value:
        !!history &&
        !!history.location &&
        !!history.location.state &&
        !!history.location.state.folio
          ? history.location.state.folio
          : !!sipDetails && !!sipDetails.folio && !!sipDetails.folio.value
          ? sipDetails.folio.value
          : "",
      label:
        !!history &&
        !!history.location &&
        !!history.location.state &&
        !!history.location.state.folio
          ? history.location.state.folio
          : !!sipDetails && !!sipDetails.folio && !!sipDetails.folio.value
          ? sipDetails.folio.value
          : "",
    };

    this.state = {
      sipTypes:
        (!!state && !!state.pan) || !checkExisting
          ? [
            { label: "Existing Folio - SIP Registration", value: EXISTING },
            {
              label: "Existing Folio - SIP Registration with payment",
              value: "EXISTINGP",
            },
            ]
          : [
              { label: "Existing Folio - SIP Registration", value: EXISTING },
              {
                label: "Existing Folio - SIP Registration with payment",
                value: "EXISTINGP",
              },
              // { label: "New Folio - SIP Registration", value: NEWP },
              // {
              //   label: "New Folio - SIP Registration with payment",
              //   value: NEW,
              // },
            ],

      invName: { value: "" },
      sipType: { value: checkMode === "ENACH" ? EXISTING : "" },
      multiples: "",
      fund: { value: "" },
      pan: { value: checkPan },
      code: { value: "+91" },
      funds: [],
      folio: { value: checkfolio },
      folios: [],
      arnCode: { value: this.props.token },
      subArnCode: { value: "" },
      subBrokerCode: { value: "" },
      schemeType: EXISTING,
      category: { value: "" },
      categories: [],
      schemes: [],
      scheme: { value: "" },
      mode: { value: checkMode },
      disbleEmail: false,
      disbleMobile: false,
      euinNo: { value: "" },
      radioValue: { value: "no" },
      minAmount: "",
      minAmountValue: { value: "" },
      frequencies: [],
      investmentFrequency: { value: "" },
      sipDays: [],
      sipDay: { value: "" },
      installments: { value: "" },
      sip_start_date: { value: "" },
      sip_end_date: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
      installmentAmount: { value: "" },
      investmentAmount: { value: "" },
      modes: [],
      maxAmount: "",
      Family_Code_Email: { value: "" },
      Family_Code_Phone: { value: "" },
      ...sipDetails,
    };
  }

  async componentDidMount() {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    const { transactionDetails } = this.props;
    if (Object.keys(transactionDetails).length > 0) {
      this.setState(transactionDetails);
      return;
    }
    this.validateBrokerCode("189")();

    // if (this.state.mode.value === "ENACH") {
    //   const { history, sipDetails } = this.props;
    //   const schemes = await this.schemes(
    //     !!history &&
    //       !!history.location &&
    //       !!history.location.state &&
    //       !!history.location.state.folio
    //       ? history.location.state.folio
    //       : !!sipDetails && !!sipDetails.folio && !!sipDetails.folio.value
    //       ? sipDetails.folio.value
    //       : ""
    //   );

    //   this.setState({
    //     minAmountValue: { value: "" },
    //     schemes,
    //     schemeType: EXISTING,
    //   });
    //   this.validateBrokerCode("189")();
    // }
  }

  handlechangeSIPEndDateChange = () => {
    const { perpetualSip } = this.state;
    if (!perpetualSip && this.state.kotm) {
      this.setState({
        perpetualSip: !this.state.perpetualSip,
        sip_end_date: {
          value: this?.state?.selectedKotm?.value["MANDATE END DATE"],
        },
        installments: {
          value: "",
          placeholder: "Perpetual SIP",
          disabled: true,
        },
      });
    } else if (!perpetualSip && !this.state.kotm) {
      this.setState({
        perpetualSip: !this.state.perpetualSip,
        sip_end_date: { value: "31/12/2099" },
        installments: {
          value: "",
          placeholder: "Perpetual SIP",
          disabled: true,
        },
      });
    } else if (!!perpetualSip) {
      this.setState({
        perpetualSip: !this.state.perpetualSip,
        sipDay: { value: "" },
        sip_end_date: { value: "" },
        sip_start_date: { value: "" },
        installments: {
          value: "",
          placeholder: "",
          disabled: false,
        },
      });
    }
  };

  // handleFundChange = async (value) => {
  //   const fund = !!value ? value.value : "";
  //   const fundValue = !!value
  //     ? this.state.sipType.value === NEW || this.state.sipType.value === NEWP
  //       ? fund.amc_code
  //       : fund.Fund
  //     : "";

  //   if (!value) {
  //     this.setState({
  //       ...initialState,
  //       funds: this.state.funds,
  //       fund: { value },
  //       schemes: [],
  //       scheme: { value: "" },
  //       modes: [],
  //       mode: { value: "" },
  //       euinNo: { value: "" },
  //       radioValue: { value: "no" },
  //       minAmount: "",
  //       frequencies: [],
  //       investmentFrequency: { value: "" },
  //       sipDays: [],
  //       sipDay: { value: "" },
  //       minAmountValue: { value: "" },
  //       installments: { value: "" },
  //       sip_start_date: { value: "" },
  //       sip_end_date: { value: "" },
  //       email: {
  //         value:
  //           this.state.sipType.value === NEW ||
  //           this.state.sipType.value === NEWP
  //             ? this.state.email.value
  //             : "",
  //       },
  //       mobile: {
  //         value:
  //           this.state.sipType.value === NEW ||
  //           this.state.sipType.value === NEWP
  //             ? this.state.mobile.value
  //             : "",
  //       },
  //       installmentAmount: { value: "" },
  //       investmentAmount: { value: "" },
  //     });
  //     return;
  //   } else if (
  //     !!value &&
  //     !!this.state.fund.value &&
  //     value.value.Fund === this.state.fund.value.value.Fund &&
  //     value.value.Fund !== undefined
  //   ) {
  //     return;
  //   } else {
  //     const params = {
  //       opt: PAYMENT_MODE,
  //       Fund: fundValue,
  //       astscheme:
  //         !!this.props.investorData && !!this.props.investorData.PAN
  //           ? this.props.investorData.PAN
  //           : "",
  //     };
  //     const folios = this.props.fundList.reduce((prev, curr) => {
  //       if (curr.Fund === fundValue && curr.sipFlag === YES) {
  //         return [...prev, curr.Acno];
  //       }
  //       return prev;
  //     }, []);
  //     this.setState({
  //       ...initialState,
  //       funds: this.state.funds,
  //       fund: { value },
  //       folios: Array.from(new Set(folios)),
  //       folio: { value: "" },
  //     });
  //     if (!!value) {
  //       this.validateBrokerCode(fundValue)();
  //     }
  //     if (
  //       this.state.sipType.value === NEW ||
  //       this.state.sipType.value === NEWP
  //     ) {
  //       this.getAssetClasses(fundValue);
  //     }
  //     const response = await this.props.swpOptions(params);
  //     if (response) {
  //       const { Dtinformation } = response;
  //       this.setState({
  //         modes: Dtinformation,
  //         minAmountValue: { value: "" },
  //         mode: { value: "" },
  //       });
  //     }
  //   }
  // };

  validateBrokerCode = (fund) => async () => {
    const { subArnCode, arnCode } = this.state;
    if (
      !!subArnCode.value &&
      subArnCode.value === arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `Sub ARN Code should not be same as ARN Code`,
        },
      });
    } else {
      const params = {
        Fund: "189",
        SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
        AgentCd: arnCode.value,
      };
      const response = await this.props.validateSubBroker(params);

      if (!!response && !!response.DtData && response.DtData.length > 0) {
        const getLength = response.DtData.length === 1;
        let value = {
          value: response.DtData[0].abm_agent,
          label: response.DtData[0].abm_agent,
        };
        if (!!getLength) {
          this.setState({
            euinNo: { value },
          });
        }
      } else if (!response) {
        this.setState({
          subArnCode: {
            value: "",
            isError: true,
            errorMessage: `(Please enter a valid Sub ARN Code)`,
          },
        });
      }
    }
  };
  getUMRN = async (type) => {
    const params = {
      Fund: "189",
      PAN: this.props.investorData.PAN,
      Acno: this.state.folio.value.value ? this.state.folio.value.value : 0,
    };
    const response =
      type === "KOTM"
        ? await this.props.getCheckPanKotm(params)
        : await this.props.getCheckPanAotm(params);
    const umrn = await response.Table1;
    if (umrn.length > 1) {
      const maxAmt = umrn.reduce(
        (max, obj) => (obj.Amt > max ? obj.Amt : max),
        0
      );
      const filteredData = umrn.filter((obj) => obj.Amt === maxAmt);
      this.setState({
        selectedKotm: { value: filteredData[0] },
      });
    }
    if (umrn.length === 1) {
      this.setState({
        selectedKotm: { value: umrn[0] },
      });
    }
    this.setState({
      umrn,
    });
  };

  handleFolioChange = (value) => {
    const folio = !!value ? value.value : "";
    const { folios } = this.state;
    const state = { folios };

    if (!value) {
      this.setState({
        ...initialState,
        ...state,
        mode: { value: this.state.mode.value },
        folio: { value },
      });
      return;
    } else if (
      !!value &&
      !!this.state.folio.value &&
      value.value === this.state.folio.value.value
    ) {
      return;
    } else {
      const schemes = this.schemes(folio);
      this.setState({
        ...initialState,
        ...state,
        mode: { value: this.state.mode.value },
        folio: { value },
        minAmountValue: { value: "" },
        schemes,
        schemeType: EXISTING,
      });
    }
  };

  changeEuin = (value) => {
    this.setState({
      euinNo: { value },
    });
  };

  changeValue = (label) => async (event) => {
    if (
      (label === "installmentAmount" || label === "investmentAmount") &&
      event.target.value.length <= 10
    ) {
      this.setState({
        [label]: { value: parseFloat(event.target.value.replace(/^0+/, "")) },
      });
    } else if (label === "mode") {
      this.setState({
        sipDay: { value: "" },
        sip_start_date: { value: "" },
        sip_end_date: { value: "" },
        perpetualSip: false,
      });
      if (event.target.value === "KOTM") {
        this.getUMRN("KOTM");
      } else if (event.target.value === "AOTM") {
        this.getUMRN("AOTM");
      }
      this.setState({
        [label]: { value: event.target.value },
        kotm: event.target.value === "KOTM" || event.target.value === "AOTM",
        selectedKotm: { value: "" },
      });
    } else if (label === "kotm") {
      this.setState({
        selectedKotm: {
          value: event.target.value,
        },
      });
    } else if (label === "code") {
        this.setState({ [label]: { value: event.target.value } });
    } else if (label === "installments" && event.target.value.length <= 3) {
      if (parseFloat(event.target.value) <= 999) {
        this.setState({
          [label]: {
            value: parseFloat(event.target.value.replace(/^0+/, "")),
          },
          sipDay: { value: "" },
          sip_start_date: { value: "" },
          sip_end_date: { value: "" },
        });
        const modeparams = {
          opt: PAYMENT_MODE,
          Fund: "189",
          astscheme:
            !!this.props.investorData && !!this.props.investorData.PAN
              ? this.props.investorData.PAN
              : !!this.state && !!this.state.pan
              ? this.state.pan
              : "",
        };
        const res = await this.props.swpOptions(modeparams);
        if (res) {
          const { Dtinformation } = res;
          this.setState({
            modes: Dtinformation,
            mode: { value: "" },
          });
        }
      } else if (!event.target.value) {
        this.setState({
          [label]: {
            value: "",
            isError: "",
            errorMessage: !!event.target.value
              ? "no of installemnts should not be more than 500"
              : "no of installments is mandatory",
          },
          sipDay: { value: "" },
          sip_start_date: { value: "" },
          sip_end_date: { value: "" },
        });
      }
    } else if (label === "mobile") {
      if ( (this.state.code.value === "+91") && (!/^[6-9]\d{9}$/.test(event.target.value))) {
        this.setState({
          [label]: {
            value: event.target.value,
            isError: true,
            errorMessage: "Enter a valid Mobile Number",
          },
        });
      } else {
        this.setState({ [label]: { value: event.target.value } });
      }
    } else if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "radioValue" && event.target.value === "no") {
      if (!this.state.euinNo.value) {
        this.setState({
          radioValue: { value: event.target.value },
        });
      } else {
        this.setState({
          [label]: { value: event.target.value },
          euinNo: { value: "" },
        });
      }
    } else if (label === "email") {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "invName" && event.target.value.length <= 40) {
      if (/^[a-zA-Z ]*$/.test(event.target.value)) {
        this.setState({
          [label]: { value: event.target.value },
        });
      }
    } else if (
      label !== "installmentAmount" &&
      label !== "invName" &&
      label !== "subArnCode" &&
      label !== "installments" &&
      label !== "subBrokerCode" &&
      label !== "email" &&
      label !== "mobile" &&
      label !== "investmentAmount" &&
      label === "radioValue" &&
      event.target.value !== "no"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  getAssetClasses = async (fund, folio) => {
    const params = {
      Fund: "189",
      Folio: folio,
    };
    const assetClasses = await this.props.getAssetClasses(params);
    if (assetClasses) {
      this.setState({
        categories: assetClasses.DtData,
      });
    }
  };

  getOtherSchemes = async (category) => {
    const params = {
      schtype: REGULAR,
      category,
      acno:
        this.state.sipType.value === NEW || this.state.sipType.value === NEWP
          ? "0"
          : this.state.folio.value.value,
      fundCode: "189",
      trantype: SIP_TRANS_TYPE,
    };

    const otherSchemes = await this.props.getOtherSchemes(params);
    const FundName = "189";

    if (otherSchemes) {
      this.setState({
        schemes: otherSchemes.DtData,
        mode: { value: this.state.mode.value },
        fund: {
          ...this.state.fund,
          errorMessage:
            (FundName.trim() === "128" ||
              FundName.trim() === "116" ||
              FundName.trim() === "189") &&
            this.state.category.value === "LIQUID" &&
            otherSchemes.DtData.length === 0
              ? "Liquid Schemes are not allowed for SIP"
              : otherSchemes.DtData.length === 0 &&
                (FundName.trim() !== "128" ||
                  FundName.trim() !== "116" ||
                  FundName.trim() !== "189")
              ? "No Schemes under this fund"
              : "",
        },
      });
    }
  };

  schemes = (folio) => {
    if (
      this.state.sipType.value === EXISTING ||
      this.state.mode.value === "ENACH" ||
      this.state.sipType.value === "EXISTINGP"
    ) {
      return this.props.fundList.reduce((prev, curr) => {
        if (
          parseFloat(curr.Fund) === 189 &&
          parseFloat(curr.Acno) === parseFloat(folio) &&
          curr.sipSchFlg === YES
        ) {
          return [...prev, curr];
        }
        return prev;
      }, []);
    }
  };

  handleCategoryChange = (event) => {
    const category = event.target.value;
    const { funds, fund, folios, folio, categories } = this.state;
    const state = {
      funds,
      fund,
      folios,

      folio,
      categories,
    };
    if (!category) {
      this.setState({
        ...initialState,
        ...state,
        category: { value: "" },
        mode: { value: this.state.mode.value },
      });
      return;
    }
    this.setState({
      ...initialState,
      ...state,
      category: { value: category },
      mode: { value: this.state.mode.value },
    });
    this.getOtherSchemes(category);
  };

  handleSipTypeChange = async (event) => {
    const sipType = event.target.value;
    const { communicationDetails, investorData } = this.props;

    const detailsEmail = communicationDetails.find(
      (detail) =>
        detail.PAN === investorData.PAN &&
        !!detail.email &&
        !!detail.Fund &&
        String(detail.Fund).trim() === "189"
    );
    const detailsMobile = communicationDetails.find(
      (detail) =>
        detail.PAN === investorData.PAN &&
        !!detail.Mobile &&
        String(detail.Fund).trim() === "189"
    );

    const Setstate = {
      ...initialState,
      schemeType: EXISTING,
      invName: {
        value:
          !!investorData && !!investorData.invname ? investorData.invname : "",
      },
      email: {
        value:
          (sipType === NEW || sipType === NEWP) &&
          // !!location.state &&
          // !location.state.pan &&
          !!detailsEmail &&
          !!detailsEmail.email
            ? detailsEmail.email
            : "",
      },
      mobile: {
        value:
          (sipType === NEW || sipType === NEWP) &&
          // !!location.state &&
          // !location.state.pan &&
          !!detailsMobile &&
          !!detailsMobile.Mobile
            ? detailsMobile.Mobile
            : "",
      },
      disbleEmail:
        !!detailsEmail &&
        !!detailsEmail.email &&
        (sipType === NEW || sipType === NEWP)
          ? true
          : false,
      disbleMobile:
        !!detailsMobile &&
        (sipType === NEW || sipType === NEWP) &&
        !!detailsMobile.Mobile
          ? true
          : false,
      mode: { value: this.state.mode.value },
    };

    if (!sipType) {
      this.setState({
        ...Setstate,
        sipType: { value: event.target.value },
        minAmountValue: { value: "" },
      });
      return;
    } else if (event.target.value === this.state.sipType.value) {
      return;
    }
    const folios = this.props.fundList.reduce((prev, curr) => {
      if (parseFloat(curr.Fund) === 189 && curr.sipFlag === YES) {
        return [...prev, curr.Acno];
      }
      return prev;
    }, []);
    this.setState({
      ...Setstate,
      sipType: { value: sipType },
      funds: [],
      fund: { value: { value: "189" } },
      folios: Array.from(new Set(folios)),
      folio: { value: "" },
      mode: { value: this.state.mode.value },
    });
    if (!!sipType) {
      this.validateBrokerCode("189")();
    }
    if (sipType === NEW || sipType === NEWP) {
      this.getAssetClasses("189");
    }

    this.setState({
      minAmountValue: { value: "" },
    });
  };

  changeSchemeType = (value) => () => {
    const { folios, folio } = this.state;
    const state = {
      folios,
      folio,
    };
    if (value === this.state.schemeType) {
      return;
    }
    if (value === EXISTING || value === "EXISTINGP") {
      const schemes = this.schemes(this.state.folio.value.value);
      this.setState({
        ...initialState,
        ...state,
        schemeType: value,
        minAmountValue: { value: "" },
        schemes,
        mode: { value: this.state.mode.value },
      });
    } else {
      this.setState({
        ...initialState,
        minAmountValue: { value: "" },
        ...state,
        schemeType: value,
        mode: { value: this.state.mode.value },
      });
      if (!!this.state.folio.value) {
        this.getAssetClasses(
          this.state.sipType.value === NEW ? "189" : "189",
          this.state.folio.value.value
        );
      }
    }
  };

  handleSchemeChange = (value) => {
    const scheme = !!value ? value.value : "";
    const { funds, fund, folios, folio, categories, category, schemes } =
      this.state;
    const state = {
      funds,
      fund,
      folios,

      folio,
      categories,
      category,
      schemes,
    };
    if (!value) {
      this.setState({
        ...initialState,
        ...state,
        scheme: { value: value },
      });
      return;
    }

    this.setState({
      ...initialState,
      ...state,
      multiples: !!scheme && !!scheme.multiples ? scheme.multiples : "",
      mode: { value: this.state.mode.value },
      scheme: { value },
      minAmount: !!scheme ? scheme.sipminamt || scheme.SIPminamt : "",
      minAmountValue: {
        value: !!scheme ? scheme.sipminamt || scheme.SIPminamt : "",
      },
      minimumLumpsumAmout:
        this.state.sipType.value === NEW
          ? scheme.fm_newpur
          : this.state.sipType.value === "EXISTINGP"
          ? scheme.MinAmt
          : "",
    });
    const params = {
      opt: INVESTMENT_FREQUENCY,
      fund: "189",
    };
    this.getInvestmentFrequency(params, "frequencies");
  };

  getInvestmentFrequency = async (params, label) => {
    const response = await this.props.swpOptions(params);
    if (response) {
      this.setState({
        [label]: response.Dtinformation,
      });
    }
  };
  FamilyDescriptionEmail = (event) => {
    this.setState({
      Family_Code_Email: { value: event },
    });
  };
  FamilyDescriptionPhone = (event) => {
    this.setState({
      Family_Code_Phone: { value: event },
    });
  };

  changeFrequency = async (event) => {
    const investmentFrequency = event.target.value;
    let minAmount = "";
    const {
      funds,
      fund,
      folios,

      folio,
      categories,
      category,
      schemes,
      scheme,
      frequencies,
    } = this.state;
    const state = {
      funds,
      fund,
      folios,

      folio,
      categories,
      category,
      schemes,
      scheme,
      frequencies,
    };
    if (!investmentFrequency) {
      this.setState({
        ...initialState,
        ...state,
        installments: { value: "" },
        sip_end_date: { value: "" },
        sip_start_date: { value: "" },
        sipDay: { value: "" },
        investmentFrequency: { value: investmentFrequency },
        mode: { value: this.state.mode.value },
      });
      return;
    }
    if (this.state.sipType.value === NEW || this.state.sipType.value === NEWP) {
      const minParams = {
        Fund: "189",
        Scheme: this.state.scheme.value.value.fm_scheme,
        Trtype: "SIP",
        Frequency: event.target.value.FrequencyID,
      };
      // const response = await this.props.getMinimumAmount(minParams);

      // if (response) {
      //   const { DtData } = response;
      //   minAmount = DtData[0].minamt;
      // }
    }
    if (this.state.sipType.value === EXISTING) {
      const minParams = {
        Fund: "189",

        Scheme:
          this.state.scheme.value.value.Sch ||
          this.state.scheme.value.value.fm_scheme,
        Trtype: "SIP",
        Frequency: event.target.value.FrequencyID,
      };
      // const response = await this.props.getMinimumAmount(minParams);
      // if (response) {
      //   const { DtData } = response;
      //   // minAmount = DtData[0].minamt;
      // }
    }

    this.setState({
      investmentFrequency: { value: investmentFrequency },
      installments: { value: "" },
      sip_end_date: { value: "" },
      sip_start_date: { value: "" },
      minAmountValue: {
        value: this.state.minAmountValue.value,
      },
    });

    const params = {
      opt: SIP_DAY,
      fund: "189",
      astscheme: investmentFrequency.FrequencyID,
    };
    this.getInvestmentFrequency(params, "sipDays");
  };

  changeSipDay = (value) => {
    const sipDay = !!value ? value.value : "";

    this.setState({
      perpetualSip: false,
      sipDay: { value: value },
      installmentAmount: { value: "" },
      investmentAmount: { value: "" },
      sip_end_date: { value: "" },
      sip_start_date: { value: "" },
    });
    if (!!sipDay && !!this.state.installments.value) {
      this.getSipEndDate(sipDay);
    } else if (!this.state.installments.value) {
      this.setState({
        sipDay: { value: "" },

        installments: {
          isError: true,
          errorMessage: "Please enter Installments",
        },
      });
      this.installmentsField.focus();
    }
  };

  changeDateFormat(date) {
    const [day, month, year] = date.split("/");
    return new Date(year, month - 1, day);
  }

  getSipEndDate = async (sipDay) => {
    const modeparams = {
      opt: PAYMENT_MODE,
      Fund: "189",
      astscheme:
        !!this.props.investorData && !!this.props.investorData.PAN
          ? this.props.investorData.PAN
          : !!this.state && !!this.state.pan
          ? this.state.pan
          : "",
    };
    const res = await this.props.swpOptions(modeparams);
    if (res) {
      const { Dtinformation } = res;
      this.setState({
        modes: Dtinformation,
      });
    }

    const params = {
      fund: "189",
      StartDate: sipDay,
      Installments: this.state.installments.value,
      Frequency: this.state.investmentFrequency.value.FrequencyID,
      trtype: "SIP",
      sch:
        this.state.scheme.value.value.Sch ||
        this.state.scheme.value.value.fm_scheme,
      modeofregistration:this.state.mode.value
    };
    const response = await this.props.CalcSIPEnddt(params);
    if (response) {
      const {
        DtData: [dates],
      } = response;
      const { SIP_EndDate, SIP_StartDate } = dates;
      if (!!SIP_EndDate) {
        const reformSIPEndDT = SIP_EndDate.split("/");
        if (parseFloat(reformSIPEndDT[2]) >= 2099) {
          this.setState({
            sipDay: { value: "" },
            sip_start_date: { value: "" },
            sip_end_date: { value: "" },
            installments: {
              value: "",
              isError: true,
              errorMessage:
                "Your SIP installments are going beyond 2099, select lesser number of installments.",
            },
          });
          this.installmentsField.focus();
        } else if (
          parseFloat(reformSIPEndDT[2]) < 2099 &&
          !!this.props.enachEndDate
        ) {
          const isStartDateValid =
            this.changeDateFormat(SIP_StartDate) >=
            this.changeDateFormat(this.props.enachStartDate);

          const isEndDateValid =
            this.changeDateFormat(SIP_EndDate) <=
            this.changeDateFormat(this.props.enachEndDate);
          if (isStartDateValid && isEndDateValid) {
            this.setState({
              sip_start_date: { value: SIP_StartDate, isError: false },
              sip_end_date: { value: SIP_EndDate, isError: false },
            });
          }
          if (!isStartDateValid) {
            this.setState({
              sip_start_date: {
                value: SIP_StartDate,
                isError: true,
                errorMessage: `SIP Start Date should be after or same as Enach Start Date (${this.props.enachStartDate})  )`,
              },
              sip_end_date: { value: SIP_EndDate, isError: false },
            });
          }
          if (!isEndDateValid) {
            this.setState({
              sip_end_date: {
                value: SIP_EndDate,
                isError: true,
                errorMessage: `SIP End Date should be before or same as Enach End Date (${this.props.enachEndDate})  )`,
              },
              sip_start_date: {
                value: SIP_StartDate,
                isError: false,
              },
            });
          }
        } else if (parseFloat(reformSIPEndDT[2]) < 2099) {
          this.setState({
            sip_start_date: { value: SIP_StartDate, isError: false },
            sip_end_date: { value: SIP_EndDate, isError: false },
          });
        }
      }
    }
  };

  showError = (label) => async (event) => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "email") {
      this.setState({
        [label]: {
          value,
          isError: !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
            this.state.email.value
          )
            ? true
            : !value,
          errorMessage: !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
            this.state.email.value
          )
            ? `Enter an vaild Email Id`
            : "",
        },
      });
    } else if (label === "mobile" ) {
      this.setState({
        [label]: {
          value,
          isError: this.state.code.value === "+91" && !/^[6-9]\d{9}$/.test(this.state.mobile.value) 
            ? true
            : !value,
          errorMessage: this.state.code.value === "+91" && !/^[6-9]\d{9}$/.test(this.state.mobile.value)
            ? `Enter a valid Phone Number`
            : !value,
        },
      });
    } else if (label === "installments") {
      this.setState({
        [label]: {
          value,
          isError:
            !!this.state.investmentFrequency.value &&
            !!this.state.investmentFrequency.value.Minimum_Instalment &&
            parseFloat(this.state.installments.value) <
              parseFloat(
                this.state.investmentFrequency.value.Minimum_Instalment
              )
              ? true
              : !value,
          errorMessage:
            !!this.state.investmentFrequency.value &&
            !!this.state.investmentFrequency.value.Minimum_Instalment &&
            parseFloat(this.state.installments.value) <
              parseFloat(
                this.state.investmentFrequency.value.Minimum_Instalment
              )
              ? "Number of installments should be greater than or equal to the minimum number of installments mentioned above"
              : "Installments is mandatory",
        },
      });
    } else if (label === "installmentAmount") {
      const { location } = this.props;
      const { state } = location;
      const { scheme } = this.state;
      const checkScheme = !!scheme && !!scheme.value && !!scheme.value.value;
      if (
        !!checkScheme &&
        (scheme.value.value.Sch === "EB" ||
          scheme.value.value.fm_scheme === "EB")
      ) {
        const params = {
          pan:
            !!this.props.investorData && !!this.props.investorData.PAN
              ? this.props.investorData.PAN
              : !!state && !!state.pan
              ? state.pan
              : "",
          amt: this.state.installmentAmount.value,
        };
        const response = await this.props.EBamountValidation(params);
        if (!!response && !!response.Dtinformation) {
          return;
        } else {
          this.setState({
            [label]: {
              value: "",
              isError: true,
              errorMessage: `${response}`,
            },
          });
        }
      } else if (
        parseFloat(this.state.minAmountValue.value) >
        parseFloat(this.state.installmentAmount.value)
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: `The amount should be ₹ ${this.state.minAmountValue.value} or more`,
          },
        });
      } else if (
        parseFloat(this.props.enachMaxAmount) <
        parseFloat(this.state.installmentAmount.value)
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: `Installment Amount should be less than or equal to ${this.props.enachMaxAmount}(₹) as per Enach Registration Amount`,
          },
        });
      } else if (
        !!this.state.installmentAmount.value &&
        !!this.state.multiples &&
        parseFloat(this.state.installmentAmount.value) %
          parseFloat(this.state.multiples) !=
          0
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: `The amount should be in the multiples of ${this.state.multiples}`,
          },
        });
      } else if (
        +this.state.selectedKotm.value.Amt < +this.state.installmentAmount.value
      ) {
        this.setState({
          installmentAmount: {
            value: "",
            isError: true,
            errorMessage: `SIP installment amount cannot exceed
          mandate registration limit of ${this.state.selectedKotm.value.Amt}.`,
          },
        });
        this.installmentAmount.focus();
        return;
      }
      return;
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
          errorMessage: `${label} is mandatory`,
        },
      });
    }
  };

  submit = async () => {
    const {
      sipTypes,
      funds,
      pan,
      folio,
      disbleEmail,
      disbleMobile,
      fund,
      folios,
      arnCode,
      subArnCode,
      invName,
      email,
      subBrokerCode,
      schemeType,
      category,
      mobile,
      categories,
      schemes,
      euinNo,
      radioValue,
      minimumLumpsumAmout,
      multiples,
      minAmount,
      minAmountValue,
      frequencies,
      sipDays,
      investmentAmount,
      installmentAmount,
      perpetualSip,
      modes,
      installments,
      maxAmount,
      code,
      Family_Code_Email,
      Family_Code_Phone,
      kotm,
      selectedKotm,
      umrn,
      ...others
    } = this.state;
    console.log(this.state)
    let d1, d2;
    const split_enddate = this?.state?.sip_end_date?.value.split("/");
    const split_mandatedate =
      this?.state?.selectedKotm?.value["MANDATE END DATE"]?.split("/");
    d1 = new Date(
      Number(split_enddate[2]),
      Number(split_enddate[1]) - 1,
      Number(split_enddate[0])
    );
    if (this?.state?.selectedKotm?.value["MANDATE END DATE"]?.split("/")) {
      d2 = new Date(
        Number(split_mandatedate[2]),
        Number(split_mandatedate[1]) - 1,
        Number(split_mandatedate[0])
      );
    }
    const { location } = this.props;
    if (
      !/^[+]\d{1,3}$/.test(code.value) &&
      (this.state.sipType.value === NEW || this.state.sipType.value === NEWP)
    ) {
      this.setState({
        [code]: {
          value: "",
          isError: true,
          errorMessage: !code.value
            ? "Country Code is Mandatory"
            : "Enter a valid Country Code",
        },
      });
      return;
    }
    if (!this.state.email.value) {
      this.setState({
        email: {
          value: "",
          isError: true,
          errorMessage: "Email ID is mandatory",
        },
      });
    }
    if (
      !/^[+]\d{1,3}/.test(this.state.code.value) &&
      (this.state.sipType.value === NEW || this.state.sipType.value === NEWP)
    ) {
      this.setState({
        code: {
          value: "",
          isError: true,
          errorMessage: !code.value
            ? "Country Code is Mandatory"
            : "Enter a valid Country Code",
        },
      });
      return;
    }
    if (
      !!this.state.sip_start_date.isError ||
      !!this.state.sip_end_date.isError
    ) {
      return;
    }
    if (!this.state.invName.value) {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor name  is mandatory",
        },
      });
    }
    if (!this.state.installmentAmount.value) {
      this.setState({
        installmentAmount: {
          value: "",
          isError: true,
          errorMessage: "installmentAmount  is mandatory",
        },
      });
    }
    if (this.state.invName.value.charAt(0) === " ") {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Enter valid name",
        },
      });
      return;
    }
    if (!this.state.mobile.value) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Mobile is mandatory",
        },
      });
    }
    if (!this.state.folio.value) {
      this.setState({
        folio: {
          value: "",
          isError: true,
          errorMessage: "Folio is mandatory",
        },
      });
    }
    if (!this.state.category.value) {
      this.setState({
        category: {
          value: "",
          isError: true,
          errorMessage: "Category is mandatory",
        },
      });
    }
    if (!this.state.investmentAmount.value) {
      this.setState({
        investmentAmount: {
          value: "",
          isError: true,
          errorMessage: "Investment Amount is mandatory",
        },
      });
    }
    if (!this.state.euinNo.value) {
      this.setState({
        euinNo: {
          value: "",
          isError: true,
          errorMessage: "EUIN No is mandatory",
        },
      });
    }
    if (!this.state.selectedKotm.value && kotm) {
      this.setState({
        selectedKotm: {
          value: "",
          isError: true,
          errorMessage: "UMRN is mandatory*",
        },
      });
    }

    const keys = Object.keys(others);

    const findError = keys.every((key) => !!others[key].value);

    const arn = this.state.arnCode.value.split("-");
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "sipType"
                  ? "SIP Type"
                  : key === "scheme"
                  ? "Scheme"
                  : key === "investmentFrequency"
                  ? "Investment frequency"
                  : key === "installments"
                  ? "Installments"
                  : key === "sipDay"
                  ? "SIP day"
                  : key === "sip_start_date"
                  ? "SIP Start date"
                  : key === "sip_end_date"
                  ? "SIP end date"
                  : key === "installmentAmount"
                  ? "Installment Amount"
                  : key
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "sipType":
          this.sipTypeField.focus();
          break;
        case "fund":
          this.fundField.focus();
          break;
        case "scheme":
          this.schemeField.focus();
          break;
        case "investmentFrequency":
          this.investmentFrequency.focus();
          break;
        case "installments":
          this.installmentsField.focus();
          break;
        case "sipDay":
          this.sipDay.focus();
          break;
        case "installmentAmount":
          this.installmentAmount.focus();
          break;

        case "email":
          this.emailField.focus();
          break;
        case "mobile":
          this.mobileField.focus();
          break;
        default:
          break;
      }
    } else if (
      invName.value === "" &&
      (this.state.sipType.value === NEW || this.state.sipType.value === NEWP)
    ) {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor name is mandatory",
        },
      });
      this.invNameField.focus();
      return;
    } else if (others.sipType === EXISTING && !folio.value) {
      this.setState({ folio: { ...folio, isError: true } });
      this.folioField.focus();
      return;
    } else if (
      (others.sipType.value === NEW || schemeType === NEW) &&
      !category.value
    ) {
      this.setState({ category: { ...category, isError: true } });
      this.categoryField.focus();
      return;
    } else if (
      (others.sipType.value === NEW || others.sipType.value === NEWP) &&
      (!email.value ||
        !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email.value))
    ) {
      this.setState({
        email: {
          ...email,
          isError: true,
          errorMessage: "Please enter an valid Email ID",
        },
      });
      this.emailField.focus();
      return;
    } else if (
      others.sipType.value === NEW &&
      (!mobile.value )
    ) {
      this.setState({ mobile: { ...mobile, isError: true } });
      this.mobileField.focus();
      return;
    } else if (radioValue.value === "no" && !euinNo.value) {
      this.setState({
        euinNo: { ...euinNo, isError: true },
      });
      this.euinField.focus();
      return;
    } else if (
      (others.sipType.value === NEW || others.sipType.value === "EXISTINGP") &&
      (!investmentAmount.value ||
        parseFloat(investmentAmount.value) <
          parseFloat(this.state.minimumLumpsumAmout))
    ) {
      if (
        parseFloat(investmentAmount.value) <
        parseFloat(this.state.minimumLumpsumAmout)
      ) {
        this.setState({
          investmentAmount: {
            value: "",
            isError: true,
            errorMessage: `Lumpsum amount should be more than ${this.state.minimumLumpsumAmout}`,
          },
        });
      } else {
        this.setState({
          investmentAmount: { ...investmentAmount, isError: true },
        });
      }

      this.investmentAmount.focus();
      return;
    } else if (arn[1] === this.state.subArnCode.value) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should  not match `,
        },
      });
    } else if (
      !!others.investmentFrequency.value &&
      !!others.investmentFrequency.value.Minimum_Instalment &&
      this.state.installments.value <
        others.investmentFrequency.value.Minimum_Instalment &&
      others.investmentFrequency.value.FrequencyID !== "Quarterly" &&
      !perpetualSip
    ) {
      this.installmentsField.focus();
      this.setState({
        installments: {
          value: "",
          isError: true,
          errorMessage: `Please check minimum no of installments`,
        },
      });
    } else if (
      this.state.minAmountValue.value > this.state.installmentAmount.value
    ) {
      this.setState({
        installmentAmount: {
          value: "",
          isError: true,
          errorMessage: `Installment Amount should be ${this.state.minAmountValue.value}(₹)`,
        },
      });
      this.installmentAmount.focus();
      return;
    }
    // else if (+this.state.installmentAmount.value > 1000000) {
    //   this.setState({
    //     installmentAmount: {
    //       value: "",
    //       isError: true,
    //       errorMessage: `Installment Amount should be less than or equal to 1,000,000(₹)`,
    //     },
    //   });
    //   this.installmentAmount.focus();
    //   return;
    // }
    else if (
      !!others.investmentFrequency.value &&
      this.state.installments.value < 4 &&
      others.investmentFrequency.value.FrequencyID === "Quarterly" &&
      !perpetualSip
    ) {
      this.setState({
        installments: {
          value: "",
          isError: true,
          errorMessage: `Please check minimum no of installments`,
        },
      });
    } else if (this.state.installmentAmount.value > this.props.enachMaxAmount) {
      this.setState({
        installmentAmount: {
          value: "",
          isError: true,
          errorMessage: `Installment Amount should be less than or equal to ${this.props.enachMaxAmount}(₹)`,
        },
      });
      this.installmentAmount.focus();
      return;
    } else if (d1 > d2) {
      this.setState({
        sip_end_date: {
          value: "",
          isError: true,
          errorMessage: `SIP end date cannot exceed mandate validity
          date of ${selectedKotm.value["MANDATE END DATE"]}.`,
        },
      });
      return;
    } else {
      this.props.setSipDetails(this.state);
      const { communicationDetails,investorData }= this.props
      const family_email_relationship = !!this.state.Family_Code_Email.value
        .value
        ? family_description_codes.find(
            (ele) =>
              ele.family_code === this.state.Family_Code_Email.value.value
          )
        : "";
      const family_mobile_relationship = !!this.state.Family_Code_Phone.value
        .value
        ? family_description_codes.find(
            (ele) =>
              ele.family_code === this.state.Family_Code_Phone.value.value
          )
        : "";
        const Xmobile = communicationDetails.find(
          (detail) =>
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.Mobile
        );
        const Xemail = communicationDetails.find(
          (detail) =>
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.email
        );
  
        const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
        const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
        
      if (
        others.sipType.value === NEW ||
        others.sipType.value === NEWP ||
        others.sipType.value === "EXISTINGP"
      ) {
        const { investorData } = this.props;
        const params = {
          InvestorName: this.state.invName.value || "",
          i_entby: this.props.userId,
          trtype: PURCHASE,
          Desci: "Yes~A~",
          SubbrokerArn: !!this.state.subArnCode.value
            ? `ARN-${subArnCode.value}`
            : "",
          ARNCode: this.state.arnCode.value,
          EuinCode:
            this.state.radioValue.value === "no"
              ? this.state.euinNo.value.value
              : "",
          i_Userid: this.props.userId,
          CountryCode: this.state.code.value,
          Mobile: others.sipType.value === "EXISTINGP"?Mobile:this.state.mobile.value,
          PanNo: investorData.PAN || this.state.pan.value,
          Email:  others.sipType.value === "EXISTINGP"? Email:this.state.email.value,
          i_Acno:
            others.sipType.value === "EXISTINGP"
              ? this.state.folio.value.value
              : "0",
          Subbroker: this.state.subBrokerCode.value,
          i_Fund: "189",
          customfund: "189", 

          i_UntAmtValue:
            this.state.sipType.value === NEW ||
            this.state.sipType.value === "EXISTINGP"
              ? this.state.investmentAmount.value
              : "",
          EUINFlag: this.state.radioValue.value === "no" ? NO : YES,
          EuinValid: this.state.radioValue.value === "no" ? NO : YES,
          noofinstallments: this.state.installments.value,
          i_Scheme:
            this.state.scheme.value.value.Sch ||
            this.state.scheme.value.value.fm_scheme,
          i_Plan:
            this.state.scheme.value.value.Pln ||
            this.state.scheme.value.value.fm_plan,
          i_Option:
            this.state.scheme.value.value.Opt ||
            this.state.scheme.value.value.fm_option,
          i_oldihno: "0",
          i_InvDistFlag: "B",
          sipenddt: new Date(
            this.state.sip_end_date.value.split("/").reverse().join("/")
          ).toLocaleDateString("en-US"),
          sipstartdt: new Date(
            this.state.sip_start_date.value.split("/").reverse().join("/")
          ).toLocaleDateString("en-US"),
          sipfrequency: this.state.investmentFrequency.value.FrequencyID,
          sipamount: this.state.installmentAmount.value,
          ModuleName: "Webile",
          paymode: this.state.mode.value,
          fEmailFlag: this.state.Family_Code_Email.value.value,
          fMobileFlag: this.state.Family_Code_Phone.value.value,
          UMRN: this.state.selectedKotm?.value?.UMRNNO,
        };
        console.log("params",params)

        const response = await this.props.submitPurchaseData(params);
        if (response) {
          const {
            DtData: [purchaseData],
          } = response;
          const confirmationParams = {
            Trtype: PURCHASE,
            fund: "189",
            customfund: "189",
            Refno: purchaseData.refno,
            ModuleName: "Webile",
          };
          const confirmationResponse =
            await this.props.showPurchaseConfirmation(confirmationParams);

          if (confirmationResponse) {
            this.props.saveTransactionDetails(this.state);
            this.props.history.push({
              pathname: NEW_TRANSACTION_URL + "/sip/digital/transact/confirm",
              state: {
                title: "SIP",
                type: SIP,
                transactiontype: this.state.sipType.value,
                mode: this.state.mode.value,
                fEmailFlag: family_email_relationship,
                fMobileFlag: family_mobile_relationship,
                InvestorEmail:
                  this.state.sipType.value === NEW ||
                  this.state.sipType.value === NEWP
                    ? this.state.email.value
                    : "",
                InvestorMobile:
                  this.state.sipType.value === NEW ||
                  this.state.sipType.value === NEWP
                    ? this.state.mobile.value
                    : "",
                arnCode: this.state.arnCode.value,
                scheme: {
                  Fund: "189",
                },
                perpetual: perpetualSip,
                UMRN: this.state.selectedKotm?.value?.UMRNNO,
              },
            });
          }
        }
      } else {
        this.props.saveTransactionDetails(this.state);
        this.props.history.push({
          pathname:
            this.state.mode.value === "ENACH"
              ? `/new-transaction/sip/digital/modes/enach-folios/transact/confirm`
              : `/new-transaction/sip/digital/modes/transact/confirm`,
          state: {
            title: "SIP",
            type: SIP,
            mode: this.state.mode.value,
            InvestorEmail:
              this.state.sipType.value === NEW ||
              this.state.sipType.value === NEWP
                ? this.state.email.value
                : "",
            InvestorMobile:
              this.state.sipType.value === NEW ||
              this.state.sipType.value === NEWP
                ? this.state.mobile.value
                : "",
            arnCode: this.state.arnCode.value,
            Folio: { value: this.state.folio.value.value },
            scheme: {
              Fund: "189",
            },
            perpetual: perpetualSip,
            isEnach: this.state.mode.value === "ENACH",
            UMRN: this.state.selectedKotm?.value?.UMRNNO,
          },
        });
      }
    }
  };

  render() {
    const {
      sipType,
      schemeType,
      fund,
      sipTypes,
      mode,
      modes,
      folios,
      folio,
      arnCode,
      subArnCode,
      subBrokerCode,
      categories,
      category,
      schemes,
      scheme,
      euinNo,
      radioValue,

      frequencies,
      investmentFrequency,
      sipDays,
      sipDay,
      installments,
      sip_end_date,
      sip_start_date,
      installmentAmount,
      investmentAmount,
      email,
      mobile,
      invName,
      Family_Code_Email,
      Family_Code_Phone,
      kotm,
      selectedKotm,
    } = this.state;
    const { euinList } = this.props;

    return (
      <div className="transaction-details">
        <div className="title">SIP Registration</div>
        {this.state.mode.value !== "ENACH" && (
          <div className="input-margin">
            <CustomizedSelect
              placeholder="Select SIP Type"
              name="SIP Type"
              borderColor="#a6a6a6"
              handleChange={this.handleSipTypeChange}
              // disabled={this.state.mode.value==="ENACH"}
              value={
                this.state.mode.value === "ENACH" ? EXISTING : sipType.value
              }
              inputRef={(ele) => (this.sipTypeField = ele)}
              isError={sipType.isError}
              errorMessage={sipType.errorMessage}
            >
              {sipTypes.map((item, index) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
        )}

        {/* {(sipType.value === NEW || sipType.value === NEWP) && (

        )} */}
        {(sipType.value === NEW || sipType.value === NEWP) && (
          <div className="input-margin">
            <div className="input-margin">
              <Input
                name="Investor Name"
                value={invName.value}
                // disabled={
                //   !!this.props.investorData && !!this.props.investorData.invname
                //     ? true
                //     : false
                // }
                onChange={this.changeValue("invName")}
                // onBlur={this.showError("invName")}
                errorMessage={invName.errorMessage}
                isShowError={invName.isError}
                inputref={(ele) => (this.invNameField = ele)}
              />
            </div>
            <div className="input-margin">
              <div className="input-name input-integrated-label">
                Email Family Description
              </div>
              <IntegrationReactSelect
                suggestions={family_description_codes.map((item) => ({
                  label: item.family_description,
                  value: item.family_code,
                }))}
                value={Family_Code_Email.value}
                placeholder="Select Family Description"
                handleChange={this.FamilyDescriptionEmail}
              />
            </div>
            <div className="input-margin">
              <Input
                name="Email"
                disabled={!!this.state.disbleEmail}
                value={email.value}
                onChange={this.changeValue("email")}
                onBlur={this.showError("email")}
                errorMessage={email.errorMessage}
                isShowError={email.isError}
                inputref={(ele) => (this.emailField = ele)}
              />
            </div>
            <div className="input-margin">
              <div className="input-name input-integrated-label">
                Mobile Family Description
              </div>
              <IntegrationReactSelect
                suggestions={family_description_codes.map((item) => ({
                  label: item.family_description,
                  value: item.family_code,
                }))}
                value={Family_Code_Phone.value}
                placeholder="Select Phone Description"
                handleChange={this.FamilyDescriptionPhone}
              />
            </div>
            <div className="input-margin">
            <CustomizedSelect
              placeholder="Country code"
              name="Country code"
              borderColor="#a6a6a6"
              handleChange={this.changeValue("code")}
              // disabled={this.state.mode.value==="ENACH"}
              value={this.state.code.value}
              // inputRef={(ele) => (this.sipTypeField = ele)}
              isError={this.state.code.isError}
              errorMessage={this.state.code.errorMessage}
            >
              {countrycodeOptions.map((item, index) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
            <div className="input-margin">
              <Input
                name="Phone no"
                value={mobile.value}
                disabled={!!this.state.disbleMobile}
                onKeyDown={(evt) =>
                  (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                  evt.preventDefault()
                }
                type="number"
                onChange={this.changeValue("mobile")}
                onBlur={this.showError("mobile")}
                isShowError={mobile.isError}
                errorMessage={mobile.errorMessage}
                inputref={(ele) => (this.mobileField = ele)}
              />
            </div>
          </div>
        )}

        {(this.state.mode.value === "ENACH" ||
          sipType.value === EXISTING ||
          sipType.value === "EXISTINGP") && (
          <div>
            <div className="input-margin">
              <div className="input-name input-integrated-label">Folio</div>
              <IntegrationReactSelect
                suggestions={folios.map((item) => ({
                  label: item,
                  value: item,
                }))}
                value={
                  this.state.mode.value === "ENACH"
                    ? this.state.folio.value
                    : folio.value
                }
                placeholder="Select Folio"
                handleChange={this.handleFolioChange}
                inputRef={(ele) => (this.folioField = ele)}
                // disabled={!fund.value}
                isError={folio.isError}
                errorMessage={folio.errorMessage}
              />
            </div>
            <div className="input-name">Select Scheme Type</div>
            <div className="radio-buttons-div">
              <Debtbutton
                buttontitle="Existing Scheme"
                width={150}
                active={schemeType === EXISTING}
                onClick={this.changeSchemeType(EXISTING)}
              />
              <Debtbutton
                buttontitle="New Scheme"
                width={150}
                active={schemeType === NEW}
                onClick={this.changeSchemeType(NEW)}
              />
            </div>
          </div>
        )}

        {(schemeType === NEW ||
          sipType.value === NEW ||
          sipType.value === NEWP) && (
          <div className="input-margin">
            <CustomizedSelect
              placeholder="Select Category"
              name="Category"
              disabled={
                sipType.value === EXISTING || sipType.value === "EXISTINGP"
                  ? !folio.value
                  : !fund.value
              }
              borderColor="#a6a6a6"
              value={category.value}
              handleChange={this.handleCategoryChange}
              inputRef={(ele) => (this.categoryField = ele)}
              isError={category.isError}
              errorMessage={category.errorMessage}
            >
              {categories.map((item, index) => (
                <MenuItem value={item.CatValue} key={index}>
                  {item.CatDesc}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
        )}
        <div className="input-margin">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
              value: item,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            // handleInputchange={this.handleInputChange}
            handleChange={this.handleSchemeChange}
            disabled={
              schemeType === EXISTING &&
              (sipType.value === EXISTING || sipType.value === "EXISTINGP")
                ? !folio.value
                : !category.value
            }
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            errorMessage={scheme.errorMessage}
          />
        </div>

        <div className="input-margin">
          <Input
            name="ARN Code"
            value={arnCode.value.split("-")[1]}
            disabled={true}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Sub ARN Code"
            disabled={!scheme.value}
            value={subArnCode.value}
            isShowError={subArnCode.isError}
            errorMessage={subArnCode.errorMessage}
            onBlur={this.validateBrokerCode(
              !!fund.value
                ? this.state.sipType.value === NEW
                  ? fund.value.value.amc_code
                  : fund.value.value.Fund
                : ""
            )}
            onChange={this.changeValue("subArnCode")}
            type={"number"}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Sub Broker Code"
            value={subBrokerCode.value}
            onChange={this.changeValue("subBrokerCode")}
            type={"number"}
          />
        </div>

        <div className="input-field-container" style={{ marginBottom: 5 }}>
          <div className="input-name">EUIN Declaration</div>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="Search"
              name="search"
              value={radioValue.value}
              style={{ flexDirection: "row" }}
              onChange={this.changeValue("radioValue")}
            >
              <div className="investor-radio-button">
                <FormControlLabel
                  value="yes"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#005DAC" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">YES</div>
              </div>
              <div className="investor-radio-button">
                <FormControlLabel
                  value="no"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#005DAC" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">NO</div>
              </div>
            </RadioGroup>
          </FormControl>
        </div>
        {radioValue.value === "no" ? (
          <div className="input-margin">
            <IntegrationReactSelect
              suggestions={euinList.map((item) => ({
                value: item.abm_agent,
                label: item.abm_agent,
              }))}
              errorMessage={euinNo.errorMessage}
              value={euinNo.value}
              placeholder="Select EUIN"
              handleChange={this.changeEuin}
              disabled={!euinList.length}
              inputRef={(ele) => (this.euinField = ele)}
              isError={euinNo.isError}
            />
          </div>
        ) : (
          <div className="euin-text">
            I/We hereby confirm that the EUIN box has been intentionally left
            the blank by me/us as this is an 'execution-only' transaction
            without any interaction or advice by any personnel of the above
            distributor or notwithstanding the advice of in-appropriateness,if
            any provided by any personnel of the distributor and the distributor
            has not charged any advisory fees on this transaction
          </div>
        )}

        <div className="input-margin">
          <CustomizedSelect
            placeholder="Investment Frequency"
            name="Investment Frequency"
            value={investmentFrequency.value}
            handleChange={this.changeFrequency}
            // onBlur={this.showError("investmentFrequency")}
            disabled={!scheme.value}
            inputRef={(ele) => (this.investmentFrequency = ele)}
            isError={investmentFrequency.isError}
            errorMessage={investmentFrequency.errorMessage}
          >
            {frequencies.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item.FrequencyDescription}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>

        <div className="input-margin">
          <Input
            value={installments.value}
            label={
              !!investmentFrequency.value
                ? investmentFrequency.value.FrequencyID !== "Quarterly"
                  ? `(Minimum : ${investmentFrequency.value.Minimum_Instalment})`
                  : `(Minimum : ${investmentFrequency.value.Minimum_Instalment})`
                : ""
            }
            name="No of Installments"
            type="number"
            bordercolor="#a6a6a6"
            onChange={this.changeValue("installments")}
            onBlur={this.showError("installments")}
            isShowError={installments.isError}
            inputref={(ele) => (this.installmentsField = ele)}
            errorMessage={installments.errorMessage}
            disabled={installments.disabled}
            placeholder={installments.placeholder}
          />
        </div>
        <div className="input-margin">
          <CustomizedSelect
            placeholder="Mode of Registration"
            name="Mode of Registration"
            // disabled={!fund.value}
            bordercolor="rgba(0, 0, 0, 0.5)"
            value={mode.value}
            handleChange={this.changeValue("mode")}
            isError={mode.isError}
            errorMessage={mode.errorMessage}
          >
            {modes.map((item, index) => (
              <MenuItem value={item.Pay_Mode} key={index}>
                {item.Pay_Mode}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>
        {kotm && (
          <div>
            <div className="input-margin">
              <CustomizedSelect
                placeholder="select UMRN"
                name="UMRN"
                borderColor="#a6a6a6"
                value={selectedKotm.value}
                handleChange={this.changeValue("kotm")}
                inputref={(ele) => (this.kotmField = ele)}
                isError={selectedKotm.error}
                errorMessage={selectedKotm.errorMessage}
                disabled={this.state?.umrn.length === 1 ? true : false}
              >
                {this.state.umrn.map((item, index) => (
                  <MenuItem value={item} key={index}>
                    {item.UMRNNO}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </div>
            <div>
              {this.state?.umrn.length === 1 && (
                <div className="euin-text">
                  The investor has only one active {this.state?.mode?.value} mandate.
                </div>
              )}
            </div>
          </div>
        )}
        {kotm && (
          <div className="redemption-details">
            <div className="keys">
              <div>Mandate amount limit</div>
              <div>Start Date</div>
              <div>End Date</div>
              <div>Bank Name</div>
              <div>Bank Account No</div>
            </div>
            <div className="values">
              <div>
                {selectedKotm.value ? selectedKotm.value.Amt : ""}
                (INR)
              </div>
              <div>
                {selectedKotm.value
                  ? selectedKotm.value["MANDATE START DATE"]
                  : ""}{" "}
              </div>
              <div>
                {selectedKotm.value
                  ? selectedKotm.value["MANDATE END DATE"]
                  : ""}
              </div>
              <div>
                {selectedKotm.value ? selectedKotm.value["BANK NAME"] : ""}
              </div>{" "}
              <div>
                {selectedKotm.value ? selectedKotm.value["BANK A/C NO"] : ""}
              </div>
            </div>
          </div>
        )}
        <div className="input-margin">
          <div className="input-name input-integrated-label">SIP Day</div>
          <IntegrationReactSelect
            suggestions={sipDays.map((item) => ({
              value: item.sip_cycleid,
              label: item.sip_cycleid,
            }))}
            value={sipDay.value}
            placeholder="SIP Day"
            handleChange={this.changeSipDay}
            // disabled={!investmentFrequency.value || !installments.value}
            inputRef={(ele) => (this.sipDay = ele)}
            isError={sipDay.isError}
            errorMessage={sipDay.errorMessage}
          />
        </div>
        <div className="input-margin">
          <Input
            name="SIP Start Date"
            disabled={true}
            value={sip_start_date.value}
            isShowError={sip_start_date.isError}
            errorMessage={sip_start_date.errorMessage}
          />
        </div>

        <div className="input-margin">
          <Input
            name="SIP End Date"
            disabled={true}
            errorMessage={sip_end_date.errorMessage}
            value={sip_end_date.value}
            isShowError={sip_end_date.isError}
          />
        </div>

        {!!sipDay && !!sipDay.value && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Checkbox
              onClick={this.handlechangeSIPEndDateChange}
              value={!!this.state.perpetualSip}
              checked={!!this.state.perpetualSip}
            />
            <div style={{ fontSize: 14 }}>Perpetual SIP</div>
          </div>
        )}

        <div className="redemption-details">
          <div className="keys">
            <div>Minimum Amount </div>
            {(sipType.value === NEW || sipType.value === "EXISTINGP") && (
              <div>Minimum Lumpsum Investment Amount </div>
            )}
          </div>
          <div className="values">
            <div>
              {!!this.state.minAmountValue
                ? this.state.minAmountValue.value
                : ""}
              (₹)
            </div>
            {(sipType.value === NEW || sipType.value === "EXISTINGP") && (
              <div>{this.state.minimumLumpsumAmout}(₹)</div>
            )}
          </div>
        </div>

        <div className="input-margin">
          <Input
            name="Installment Amount (₹)"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            bordercolor="#a6a6a6"
            value={installmentAmount.value}
            onChange={this.changeValue("installmentAmount")}
            type="number"
            onBlur={this.showError("installmentAmount")}
            isShowError={installmentAmount.isError}
            inputref={(ele) => (this.installmentAmount = ele)}
            errorMessage={installmentAmount.errorMessage}
          />
        </div>

        {(sipType.value === NEW || sipType.value === "EXISTINGP") && (
          <Input
            name="Lumpsum Investment Amount (₹)"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            bordercolor="#a6a6a6"
            value={investmentAmount.value}
            onChange={this.changeValue("investmentAmount")}
            type="number"
            onBlur={this.showError("investmentAmount")}
            isShowError={investmentAmount.isError}
            inputref={(ele) => (this.investmentAmount = ele)}
            errorMessage={investmentAmount.errorMessage}
          />
        )}
        {!!this.props.enachMaxAmount && (
          <div
            style={{
              fontSize: 15,
              color: "#194b7e",
            }}
          >
            <span style={{ color: "#005DAC" }}>Note:</span>
            {`As per the ENACH Registration - Maximum Amount is Rs. ₹ ${this.props.enachMaxAmount}`}
          </div>
        )}
        {!!this.props.enachBank && (
          <div
            style={{
              fontSize: 15,
              color: "#194b7e",
            }}
          >
            <span style={{ color: "#005DAC" }}>Bank account number:</span>{" "}
            {this.props.enachBank}
          </div>
        )}
        {!!this.props.umr && (
          <div
            style={{
              fontSize: 15,
              color: "#194b7e",
              marginTop: 5,
            }}
          >
            <span style={{ color: "#005DAC" }}>UMRN number:</span>{" "}
            {this.props.umr}
          </div>
        )}
        <div className="digital-form-button-next-div">
          <Signbutton buttontitle="Submit" onClick={this.submit} />
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      investorData,
      communicationDetails,
      enachBank,
      umr,
      enachStartDate,
      enachEndDate,
      enachMaxAmount,
    } = authReducer;
    const {
      transactionDetails,
      euinList,
      fundsList,
      sipDetails = {},
    } = transactions;
    return {
      fundList,
      token,
      userId,
      euinList,
      investorData,
      communicationDetails,
      fundsList,
      sipDetails,
      enachBank,
      umr,
      enachStartDate,
      enachEndDate,
      enachMaxAmount,
      transactionDetails,
    };
  },
  {
    validateSubBroker,
    swpOptions,
    getNewPurchaseFundList,
    EBamountValidation,
    getOtherSchemes,
    getAssetClasses,
    CalcSIPEnddt,
    setSipDetails,
    getCheckPanKotm,
    getCheckPanAotm,
    submitPurchaseData,
    showPurchaseConfirmation,
    getMinimumAmount,
    saveTransactionDetails,
  }
)(Sip);
export const family_description_codes = [
  {
    family_description: "Self",
    family_code: "SE",
  },
  {
    family_description: "Spouse",
    family_code: "SP",
  },
  {
    family_description: "Dependent Children",
    family_code: "DC",
  },
  {
    family_description: "Dependent Siblings",
    family_code: "DS",
  },
  {
    family_description: "Dependent Parents",
    family_code: "DP",
  },
  {
    family_description: "Guardian",
    family_code: "GD",
  },
];
